import { z } from 'zod';
import { expectType, zDocument } from './model.js';
export const zBackup = zDocument.extend({
    type: z.literal('backup'),
    document: z.intersection(z.record(z.any()), zDocument),
    lastUpdatedBy: z.string()
});
expectType({});
expectType({});
